import { Router } from '@aibees/elephant/router';
import { KpiRouteTracker } from '@aibees/shared/features';
import { useScrollToTop } from '@aibees/shared/hooks';
import { UpdateNotification } from './core/components/update-notification';
import { useGleapIdentifyEffect } from './core/hooks/use-gleap-identify-effect';
import { useGleapVisibility } from './core/hooks/use-gleap-visibility';
import RootLayout from './core/layouts/root-layout';

export default function App() {
  useScrollToTop();
  useGleapVisibility();
  useGleapIdentifyEffect();

  return (
    <RootLayout>
      <UpdateNotification />
      <KpiRouteTracker />
      <Router />
    </RootLayout>
  );
}
